import { render, staticRenderFns } from "./Cashback.vue?vue&type=template&id=20b69e64&"
import script from "./Cashback.vue?vue&type=script&lang=ts&"
export * from "./Cashback.vue?vue&type=script&lang=ts&"
import style0 from "./Cashback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports